export default __webpack_public_path__ + "static/media/Selected-hcp-icon-big-new.9d80d868.svg";